import {Component, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ReplaySubject, Observable} from 'rxjs';
import {ActivatedRoute} from '@angular/router';
import {ProfessionalReferenceScreensManager} from './professional-reference-screens-manager.service';
import {ProfessionalReferenceService} from '../../../../domain/model/reference/professional-reference.service';
import {FormErrors} from '../../../../components/forms/validation/form-validator.class';
import {ProfessionalReference} from '../../../../domain/model/reference/professional-reference.model';
import {StepScreenModel} from '../../../shared/step/step-screen.component';
import {MonthPickerComponentModel} from '../../../../components/forms/controls/monthpicker/month-picker.component';
import {PracticeSpecialtyService} from '../../../../domain/model/info/practicespecialty/practice-specialty.service';
import moment = require('moment');

@Component({
    template: require('./professional-reference-screen.component.html')
})
export class ProfessionalReferenceScreenComponent {

    constructor(readonly modelService: ProfessionalReferenceService,
                readonly route: ActivatedRoute,
                readonly screensManager: ProfessionalReferenceScreensManager,
                practiceSpecialtyService: PracticeSpecialtyService) {

        practiceSpecialtyService.getPracticeSpecialties().subscribe(
            specialties => this.practiceSpecialties = specialties.map(s => s.name)
        );

        this._refreshTitle();
        this.stepScreenModel.dataModel$.subscribe(model => this._refreshTitle(model.name));
    }

    // region Form
    readonly form$ = new ReplaySubject<NgForm>(1);

    @ViewChild(NgForm) set form(value: NgForm) {
        this.form$.next(value);
    }

    // endregion

    practiceSpecialties: Array<string> = [];
    phoneMask = ['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    workedWithDurationDateConstrains = {
        minDate: moment().subtract(100, 'year'),
        maxDate: moment().add(5, 'year')
    };
    workedWithDurationFromMonthPickerModel = new MonthPickerComponentModel(this.workedWithDurationDateConstrains);
    workedWithDurationToMonthPickerModel = new MonthPickerComponentModel(this.workedWithDurationDateConstrains);

    get index(): number {
        return +this.route.snapshot.params['index'];
    }

    title: string;

    stepScreenModel = new StepScreenModel<ProfessionalReference>({
        initialDataModel: new ProfessionalReference(),
        specificValidationMessages: {},
        screensManager: this.screensManager,
        _loadDataFn: () => {
            return this.modelService.getCurrentUserModelEntry(this.index);
        },
        _submitDataFn: (model: ProfessionalReference) => {
            return this.modelService.updateCurrentUserModelEntry(this.index, model);
        },
        _hasYesNoQuestion: () => this.index > 3 ? this.modelService.doesCurrentUserModelEntryExist(this.index).map(r => !r) : Observable.of(false)
    });

    get model(): ProfessionalReference {
        return this.stepScreenModel.dataModel;
    }

    get formErrors(): FormErrors {
        return this.stepScreenModel.formErrors;
    }

    private _refreshTitle(name?: string) {
        this.title = `Professional Reference ${name ? `- ${name}` : ''} ${this.index <= 3 ? `(${this.index} of 3)` : ''}`;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/references/steps/professional/professional-reference-screen.component.ts